<template>
<div class="talkWithGuide-Intro">
    <header class="talkWithGuide-Intro-Header">
        <div class="text-center">
            <div class="avatar" :style="`background-image: url(/img/avatarMax.png)`"></div>
        </div>
        <p>Talk with a security guide for <br> live support</p>
        <div class="talkWithGuide-Intro-HeaderLink">
            <a :href="supportNumberLink">
                <i class="fa fa-phone"></i>
                {{ supportNumber }}
            </a>
        </div>
        <div class="talkWithGuide-Intro-HeaderLink">
            <a href="javascript:;" @click="showChat">
                <i class="fa fa-comments"></i>
                Live chat 
            </a>
        </div>
    </header>
    <footer class="talkWithGuide-Intro-Footer">
        <div class="talkWithGuide-sectionDots">
            <div class="dot active"></div>
            <div class="dot"></div>
        </div>
        <p>Or leave your contact info and we’ll <br> reach out to you.</p>
        <FormInput
            placeholder="What is your name?"
            type="text"
            :value="lead.name"
            leadKey="name" />
        <FormInput
            placeholder="What's your phone number?"
            type="tel"
            mask="(###) ###-####"
            :value="lead.phone"
            leadKey="phone" />
        <button type="button" @click="changeSection('Consent')" class="button full">Continue</button>
        
    </footer>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormInput from '../../components/FormInput.vue'
export default {
    components: {
        FormInput
    },
    props: ['changeSection'],
    computed: {
        ...mapState([
            'supportNumber',
            'supportNumberLink',
            'lead'
        ])
    },
    methods: {
        ...mapActions(['showChat']),
    }
}
</script>

<style lang="css"></style>
